// AUTOGENERATED FILE
// source: scripts/generate-product-types-templates.ts

import React from 'react'
import { ReactComponent as TemplateSVG } from '../../../../../assets/product-templates/svg/auto-bottom-template.svg'

export const AutoBottomTemplate = (props: React.SVGProps<SVGSVGElement>) => {
  return <TemplateSVG {...props} />
}
